var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMenuMore = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "#1B1F23",
  "aria-hidden": "true",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M16 10a2 2 0 1 1 0-4 2 2 0 0 1 0 4m0 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4m0 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4"
})));
export default SvgMenuMore;